import { Component, Inject, OnInit } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material";
import { AnounceModalResult } from "../../shared/contentTypes";

export interface AnnounceDialogModalData {
  /** Titel (langkey placeholder) */
  title: string;
  /** Content (langkey placeholder) */
  content: string;
  /** FirstButton Label (langkey placeholder) */
  firstBtnLabel: string;
  /** SecondButton Label (langkey placeholder) */
  secondBtnLabel: string;
  /** ThirdButton Label (langkey placeholder) optional */
  thirdBtnLabel?: string;
}

@Component({
  selector: "app-announcedialog",
  templateUrl: "./announceDialog.component.html",
  styleUrls: ["./announceDialog.component.scss"]
})
export class AnnounceDialogComponent implements OnInit {

  constructor(public bottomSheetRef: MatBottomSheetRef<AnnounceDialogComponent, AnounceModalResult>
    , @Inject(MAT_BOTTOM_SHEET_DATA) public announceData: AnnounceDialogModalData) {
  }

  ngOnInit() {
  }

  /** return AnounceModalResult.FirstButton to define first buttom event */
  public firstBtnClick() {
    const me = this;
    me.bottomSheetRef.dismiss(AnounceModalResult.FirstButton);
  }

  /** return AnounceModalResult.SecondButton to define second buttom event */
  public secondBtnClick() {
    const me = this;
    me.bottomSheetRef.dismiss(AnounceModalResult.SecondButton);
  }

  public thirdBtnClick() {
    const me = this;
    me.bottomSheetRef.dismiss(AnounceModalResult.ThirdButton);
  }
}
